import "babel-polyfill"
import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Spinner from '../../common/components/spinner/spinner';
import MedicineService from '../../services/medicineService';
import { MedicineBasicModel } from "../../models";
import OverViewTab from './MedicineNavigation/overViewTab';
import SideEffectsTab from './MedicineNavigation/sideEffectsTab';
import DosageTab from './MedicineNavigation/dosageTab';
import ProfessionalTab from './MedicineNavigation/professionalTab';
import Translate from '../../common/functions/translate';
import InteractionsTab from './MedicineNavigation/interactionsTab';
import { BrowserRouter, Route, Link, Switch, Redirect } from "react-router-dom";
import { MedicineTabs, AuthorisationStatus, DataSourceType } from '../../common/enums';
import LeafletTab from './MedicineNavigation/leafletTab';
import { connect } from 'react-redux';
import PregnancyTab from './MedicineNavigation/pregnancyTab';
import DriveMachineTab from './MedicineNavigation/driveMachineTab';
import { Accordion, AccordionTab } from 'primereact/accordion';
import * as Constants from '../../common/constants';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import Fab from '@material-ui/core/Fab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faChevronUp } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  match: any,
  history: any,
  lang: string,
  classes: any
}

interface IState {
  isLoading: boolean,
  medicineId: number,
  error: any,
  currentMedicine: MedicineBasicModel,
  menuTabs: any,
  activeIndex: any,
  lang: string,
  value: number,
  showUpIcon: boolean
}

class medicineDetails extends React.Component<IProps, IState> {
  redirect: boolean;
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    let currentMedicine = new MedicineBasicModel();
    currentMedicine.medicineTabs = new Array<MedicineTabs>(0);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.match.params.MedicineId,
      currentMedicine: currentMedicine,
      menuTabs: [],
      lang: this.props.lang,
      value: 0,
      activeIndex: null,
      showUpIcon: false
    };

  }

  // events
  componentDidMount() {
    this.getMedicineBasic();

    window.addEventListener('scroll', this.onScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang != this.props.lang) {
      this.initializeTabs();
    }
  }

  onScroll = () => {
    if (window.pageYOffset && window.pageYOffset > 0) {
      this.setState({ showUpIcon: true });
    } else {
      this.setState({ showUpIcon: false });
    }
  };

  // methods
  getMedicineBasic() {
    this.setState({
      isLoading: true
    });

    this.medicineService.getMedicineBasic(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          currentMedicine: data.data
        });

        this.initializeTabs();

      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  initializeTabs() {
    let tabEnum = MedicineTabs;
    let tabNames: Array<any> = [];

    this.state.currentMedicine.medicineTabs.map(i =>
      tabNames.push(Object.keys(tabEnum).find(k => tabEnum[k] === i))
    );

    if (tabNames.length > 0) {
      let currentTabObjects: Array<tabItem> = [];
      tabNames.map(m =>
        currentTabObjects.push({ label: Translate(m), tabRouteName: m.toLowerCase() })
      );

      let tabIndex = this.props.match.params.TabName ?
        currentTabObjects.findIndex(i => i.tabRouteName == this.props.match.params.TabName) :
        null;

      this.setState({
        isLoading: false,
        menuTabs: currentTabObjects,
        activeIndex: tabIndex
      });
    }
  }

  handleTabMenuchange = (event, value) => {
    if (value != null) {
      this.setState({ activeIndex: value });
    } else {
      this.setState({ activeIndex: null });
    }
  }

  getTabComponent = (tabName) => {

    const { currentMedicine, activeIndex, menuTabs } = this.state;

    let activeRouteName = menuTabs && menuTabs[activeIndex] ? menuTabs[activeIndex].tabRouteName : '';

    switch (tabName) {
      case 'overview':
        return activeRouteName == 'overview' ? <OverViewTab medicineId={currentMedicine.medicineId} /> : null;
      case 'sideeffects':
        return activeRouteName == 'sideeffects' ? <SideEffectsTab medicineId={currentMedicine.medicineId} /> : null;
      case 'dosage':
        return activeRouteName == 'dosage' ? <DosageTab medicineId={currentMedicine.medicineId} /> : null;
      case 'interactions':
        return activeRouteName == 'interactions' ?
          <>
            <InteractionsTab medicineId={currentMedicine.medicineId} history={this.props.history} match={this.props.match} />
          </> : null;
      case 'pregnancy':
        return activeRouteName == 'pregnancy' ? <PregnancyTab medicineId={currentMedicine.medicineId} /> : null;
      case 'drivemachine':
        return activeRouteName == 'drivemachine' ? <DriveMachineTab medicineId={currentMedicine.medicineId} /> : null;
      // case 'professional':
      //   return activeRouteName == 'professional' ? <ProfessionalTab medicineId={currentMedicine.medicineId} /> : null;
      case 'leaflets':
        return activeRouteName == 'leaflets' ? <LeafletTab medicineId={currentMedicine.medicineId} /> : null;
      default:
        return null;
    }
  }

  searchMedicinesByActiveIngredient = (event, genericId: number) => {
    event.preventDefault();
    this.props.history.push(`${Constants.MedicinesUrl}?activeIngredient=${encodeURI(genericId.toString())}`);
  }

  // render
  public render() {

    const { menuTabs, currentMedicine, isLoading, error, activeIndex, showUpIcon } = this.state;

    let medicineName = currentMedicine.brandName ? currentMedicine.brandName : '';

    return (
      <div className="app-content">
        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        <div className="title">
          {medicineName}
          {currentMedicine.authorisationStatus > 0 && currentMedicine.authorisationStatus != AuthorisationStatus.Authorised ?
            <span style={{ color: '#ff0000' }}> - {HelperFunctions.getEnumLabel(currentMedicine.authorisationStatus, AuthorisationStatus, true)}</span> : null}
        </div>

        <div className="subtitle">{currentMedicine.additionalTitle}</div>

        <div style={{ marginBottom: "10px" }}>
          <div><strong>{Translate('GenericName')}: </strong>{currentMedicine.generics && currentMedicine.generics.length > 0 ? currentMedicine.generics.map(g =>
            <a key={g.genericId + 'generic'} href="" onClick={(e) => this.searchMedicinesByActiveIngredient(e, g.genericId)}>{g.genericName}</a>
          ).map((item, index) => [index > 0 && ', ', item]) : null}
          </div>
          <div><strong>{Translate('BrandName')}:</strong> {medicineName}</div>
        </div>

        {currentMedicine.dataSourceTypeId > 0 ?
          <div className="subtitle" style={{ fontStyle: 'italic' }}>
            {Translate('DataSource')}:
            <a href={currentMedicine.medicineDataURL ? currentMedicine.medicineDataURL : Constants.BdaUrl} target='_blank'>
              <span> {HelperFunctions.getEnumLabel(currentMedicine.dataSourceTypeId, DataSourceType, true)} </span>
            </a>
          </div> : null}


        {currentMedicine.medicineNumber || currentMedicine.emaProductNumber ?
          <div className="subtitle" style={{ fontStyle: 'italic' }}>
            {Translate('Porduct Number')}:
              {currentMedicine.medicineNumber ? <span> {currentMedicine.medicineNumber}</span> : null}
            {currentMedicine.medicineNumber && currentMedicine.emaProductNumber ? " | " : null}
            {currentMedicine.emaProductNumber ? <span> {currentMedicine.emaProductNumber}</span> : null}
          </div> : null}
        <div>
          <Accordion activeIndex={activeIndex} onTabChange={(e) => this.handleTabMenuchange(e, e.index)}>
            {menuTabs.map((m, index) =>
              <AccordionTab key={index} header={m.label}>
                {this.getTabComponent(m.tabRouteName)}
              </AccordionTab>
            )}
          </Accordion>

          {showUpIcon ?
            <div className="floating-action-button-up">
              <Fab color="primary" aria-label="Up" size="medium" onClick={() => window.scrollTo(0, 0)} >
                <FontAwesomeIcon size="2x" icon={faChevronUp} />
              </Fab>
            </div> : null}

        </div>
      </div>
    );
  }
}

class tabItem {
  label: string;
  tabRouteName: string;
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(medicineDetails);